import { isRouteErrorResponse, useRouteError, Link } from "react-router-dom";

export function ErrorPage() {
  const error = useRouteError();

  let title = "Oops! Something went wrong";
  let message = "We're sorry, but an unexpected error occurred while processing your request.";

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      title = "404 - Page Not Found";
      message = "The page you are looking for doesn't exist or has been moved.";
    } else {
      title = `${error.status} - ${error.statusText}`;
      message = error.data?.message || message;
    }
  } else if (error instanceof Error) {
    message = error.message;
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] px-4 text-center">
      <div className="max-w-md space-y-6 rounded-3xl bg-white p-8 shadow-xl ring-1 ring-black/5 dark:bg-slate-900 dark:ring-white/10">
        <h1 className="font-display text-3xl font-bold tracking-tight text-nv-ink dark:text-white sm:text-4xl">
          {title}
        </h1>
        <p className="text-lg text-nv-slate dark:text-slate-300">
          {message}
        </p>
        <div className="pt-4">
          <Link
            to="/"
            className="inline-flex h-12 w-full items-center justify-center rounded-full bg-blue-600 px-8 font-bold text-white shadow-lg transition-transform hover:scale-105 hover:bg-blue-500 active:scale-95"
          >
            Return to Homepage
          </Link>
        </div>
      </div>
    </div>
  );
}
